import { yup } from '@guiker/yup-util'

export const awsCredentialsSchema = yup
  .object({
    accessKeyId: yup.string().required(),
    secretAccessKey: yup.string().required(),
  })
  .required()
